export class MetaStore {
    constructor(metaData) {
        this.data = metaData ?? {};
        this.badges = new MetaBadges(this.data);
    }
}
class MetaBadges {
    constructor(metaData) {
        this.groups = {};
        // 'overlay' group is created by default - could support additional groups via config in the future
        const groups = { overlay: { sections: ['left', 'right'] } };
        // process groups - create the grid for each group
        Object.keys(groups).map((name) => {
            const group = groups[name];
            const sections = group.sections.map((section) => ({
                areas: metaData?.badges?.locations?.[section]?.map((area) => area.tag) || [],
                grid: [],
            }));
            // find lcm of sections
            const lcmSections = sections.map((section) => section.areas.length).reduce(lcm);
            sections.forEach((section) => {
                section.grid = Array.from({ length: lcmSections }).map((_, index) => section.areas[Math.floor(index / (lcmSections / section.areas.length))]);
            });
            // set the grid by creating rows of columns
            const grid = Array.from({ length: lcmSections }).map((_, i) => {
                return sections.map((section) => section.grid[i]);
            });
            this.groups[name] = {
                sections: group.sections,
                grid,
            };
        });
    }
}
function gcd(a, b) {
    if (!b) {
        return a;
    }
    return gcd(b, a % b);
}
function lcm(a, b) {
    const gcdValue = gcd(a, b);
    return (a * b) / gcdValue;
}
